import { useEffectEvent } from "@repo/ui/helpers/useEffectEvent";
import { useContext, useEffect } from "react";
import { KeyboardShortcutsContext } from "./keyboardShortcutsContext.js";

export function useKeyboardShortcutEffect(
  eventName: string | symbol,
  onTrigger: () => void,
) {
  const keyboardShortcutsEmitter = useContext(KeyboardShortcutsContext);
  const handleKeyboardShortcut = useEffectEvent(onTrigger);

  useEffect(() => {
    keyboardShortcutsEmitter.on(eventName, handleKeyboardShortcut);

    return () => {
      keyboardShortcutsEmitter.off(eventName, handleKeyboardShortcut);
    };
  }, [eventName, keyboardShortcutsEmitter, handleKeyboardShortcut]);
}
